
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PayrollProcessRepository } from './repository/payroll-process.repo';
import { PayrollLogsRepository } from './repository/payroll-logs.repo';
import { PayrollProcessController } from './payroll-process.controller';
import { PayrollProcessService } from './payroll-process.service';
import { AttendanceRepository } from '../attendance/repository/attendance.repository';
import { PayslipProcessRepository } from './repository/payslip.repo';
import { PayrollLogs } from './entity/payroll-log';
import { MailerService } from './send-mail';
import { PayrollComponentLogsRepository } from './repository/payroll-component-process.repo';


@Module({
    imports: [
        TypeOrmModule.forFeature([PayrollLogs, PayrollLogsRepository,PayrollProcessRepository,AttendanceRepository,PayslipProcessRepository, PayrollComponentLogsRepository])
    ],
    controllers: [PayrollProcessController],
    providers: [PayrollProcessService,MailerService],
    exports: [PayrollProcessService]
})
export class PayrollProcessModule { }